import { CardData, SideBySideData, SideBySideApiPayload } from '../../types';
import constants from '../constants';

const { SIDE_BY_SIDE_DEFAULTS } = constants;

export const defaultCardData: CardData = {
    ...SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD,
};

export const defaultSideBySideData: SideBySideData = {
    sectionTitle: '',
    sectionTitleColor: SIDE_BY_SIDE_DEFAULTS.SECTION_TITLE_COLOR,
    sectionSubtitle: '',
    sectionSubtitleColor: SIDE_BY_SIDE_DEFAULTS.SECTION_SUBTITLE_COLOR,
    card1: { ...defaultCardData },
    card2: { ...defaultCardData },
};

export const parseApiResponse = (response: any): SideBySideData => {
    if (!response) return defaultSideBySideData;

    try {
        const parsed = response.p ? JSON.parse(response.p) : response;
        return {
            sectionTitle: parsed.sectionTitle || '',
            sectionTitleColor: parsed.sectionTitleColor || SIDE_BY_SIDE_DEFAULTS.SECTION_TITLE_COLOR,
            sectionSubtitle: parsed.sectionSubtitle || '',
            sectionSubtitleColor: parsed.sectionSubtitleColor || SIDE_BY_SIDE_DEFAULTS.SECTION_SUBTITLE_COLOR,
            card1: {
                image: parsed.card1Image || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.image,
                altText: parsed.card1AltText || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.altText,
                overlayOpacity: parsed.card1OverlayOpacity ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.overlayOpacity,
                imageRadius: parsed.card1ImageRadius ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.imageRadius,
                objectFit: parsed.card1ObjectFit || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.objectFit,
                title: parsed.card1Title || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.title,
                subtitle: parsed.card1Subtitle || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.subtitle,
                btnText: parsed.card1BtnText || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.btnText,
                link: parsed.card1Link || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.link,
                openInNewTab: parsed.card1OpenInNewTab ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.openInNewTab,
                titleColor: parsed.card1TitleColor || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.titleColor,
                subtitleColor: parsed.card1SubtitleColor || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.subtitleColor,
                btnColor: parsed.card1BtnColor || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.btnColor,
                showArrow: parsed.card1ShowArrow ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.showArrow,
            },
            card2: {
                image: parsed.card2Image || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.image,
                altText: parsed.card2AltText || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.altText,
                overlayOpacity: parsed.card2OverlayOpacity ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.overlayOpacity,
                imageRadius: parsed.card2ImageRadius ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.imageRadius,
                objectFit: parsed.card2ObjectFit || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.objectFit,
                title: parsed.card2Title || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.title,
                subtitle: parsed.card2Subtitle || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.subtitle,
                btnText: parsed.card2BtnText || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.btnText,
                link: parsed.card2Link || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.link,
                openInNewTab: parsed.card2OpenInNewTab ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.openInNewTab,
                titleColor: parsed.card2TitleColor || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.titleColor,
                subtitleColor: parsed.card2SubtitleColor || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.subtitleColor,
                btnColor: parsed.card2BtnColor || SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.btnColor,
                showArrow: parsed.card2ShowArrow ?? SIDE_BY_SIDE_DEFAULTS.DEFAULT_CARD.showArrow,
            },
        };
    } catch {
        return defaultSideBySideData;
    }
};

export const buildApiPayload = (data: SideBySideData): SideBySideApiPayload => ({
    sectionTitle: data.sectionTitle,
    sectionTitleColor: data.sectionTitleColor,
    sectionSubtitle: data.sectionSubtitle,
    sectionSubtitleColor: data.sectionSubtitleColor,
    card1Image: data.card1.image,
    card1AltText: data.card1.altText,
    card1OverlayOpacity: data.card1.overlayOpacity,
    card1ImageRadius: data.card1.imageRadius,
    card1ObjectFit: data.card1.objectFit,
    card1Title: data.card1.title,
    card1Subtitle: data.card1.subtitle,
    card1BtnText: data.card1.btnText,
    card1Link: data.card1.link,
    card1OpenInNewTab: data.card1.openInNewTab,
    card1TitleColor: data.card1.titleColor,
    card1SubtitleColor: data.card1.subtitleColor,
    card1BtnColor: data.card1.btnColor,
    card1BtnBgColor: '#FFFFFF',
    card1BtnTextColor: data.card1.btnColor,
    card1ShowArrow: data.card1.showArrow,
    card2Image: data.card2.image,
    card2AltText: data.card2.altText,
    card2OverlayOpacity: data.card2.overlayOpacity,
    card2ImageRadius: data.card2.imageRadius,
    card2ObjectFit: data.card2.objectFit,
    card2Title: data.card2.title,
    card2Subtitle: data.card2.subtitle,
    card2BtnText: data.card2.btnText,
    card2Link: data.card2.link,
    card2OpenInNewTab: data.card2.openInNewTab,
    card2TitleColor: data.card2.titleColor,
    card2SubtitleColor: data.card2.subtitleColor,
    card2BtnColor: data.card2.btnColor,
    card2BtnBgColor: '#FFFFFF',
    card2BtnTextColor: data.card2.btnColor,
    card2ShowArrow: data.card2.showArrow,
});
